var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.697 8.972a1.004 1.004 0 0 1 1.427-.001l3.606 3.642c.149.15.391.15.54 0l3.606-3.642a1.004 1.004 0 0 1 1.427 1.412l-4.942 5.002a.507.507 0 0 1-.722 0l-4.942-5.002a1.004 1.004 0 0 1 0-1.411"
  })));
};
export default SvgChevronDown;